import type { MenuProps } from 'antd';
import { useChatContext } from '@/contexts/chat/context';
import { ChatCategory, type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import MenuArea from '@/components/contextMenu/MenuArea';
import type { MenuAreaRef } from '@/components/contextMenu/MenuArea';
import DeleteIcon from './images/delete.svg?react';
import styles from './index.module.scss';

const ChatContextMenu = ({
  chat,
  menuAreaRef,
  visible,
  points,
}: {
  chat: Chat;
  menuAreaRef: React.RefObject<MenuAreaRef>;
  visible: boolean;
  points: { x: string; y: string };
}) => {
  const {
    deleteChat,
    chatGroup: { deleteGroupWithRelated },
  } = useChatContext();
  const clearChatHistoryRef = useRef(true);

  const items: MenuProps['items'] = [
    {
      key: 'DELETE',
      label: (
        <div className={cls(styles.label, styles.delete)}>
          <DeleteIcon />
          Delete
        </div>
      ),
      danger: true,
    },
  ];

  const Content = ({
    checked,
    onChange,
  }: {
    checked: boolean;
    onChange: (value: boolean) => void;
  }) => {
    const [value, setValue] = useState(checked);
    return (
      <Checkbox
        className={styles.checkbox}
        checked={value}
        onChange={(e) => {
          setValue(e.target.checked);
          onChange?.(e.target.checked);
        }}
      >
        <span>Clear chat history</span>
      </Checkbox>
    );
  };

  const handleDelete = useCallback(async () => {
    Dialog({
      title: <div>{`Pemanenrly delete the chat with ${chat.name} ?`}</div>,
      content: (
        <Content
          checked={clearChatHistoryRef.current}
          onChange={(value) => {
            clearChatHistoryRef.current = value;
          }}
        ></Content>
      ),
      onConfirm: () => {
        if (chat.category === ChatCategory.SINGLE) {
          deleteChat(chat.chat_id, clearChatHistoryRef.current);
        } else {
          deleteGroupWithRelated(chat.chat_id, clearChatHistoryRef.current);
        }
        clearChatHistoryRef.current = true;
      },
      onCancel: () => {
        clearChatHistoryRef.current = true;
      },
    });
  }, [chat.category, chat.chat_id, chat.name, deleteChat, deleteGroupWithRelated]);

  const handleItemClick: MenuProps['onClick'] = ({ key }) => {
    switch (key) {
      case 'DELETE':
        handleDelete();
        break;
    }
  };

  return (
    <MenuArea
      className={styles.chatContextMenu}
      ref={menuAreaRef}
      visible={visible}
      points={points}
      items={items}
      onClick={handleItemClick}
      selectedKeys={[]}
    ></MenuArea>
  );
};

export default ChatContextMenu;
